export default __webpack_public_path__ + "static/media/Size4.11de3d6b.png";